module.exports = __webpack_public_path__ + "img/delete.82758e2a.svg";